import React from 'react';

import ForumPostList from '../Forum/ForumPostList';
import styles from './styles.module.scss';

const SearchPostsList = ({ content }) => {
  return (
    <>
      {content?.length > 0 ? (
        <div className={styles.forumPostList}>
          <ForumPostList forumPosts={content} />
        </div>
      ) : (
        <p className="serif no-content-message">No results found!</p>
      )}
    </>
  );
};

export default SearchPostsList;
